<template>
    <v-flex
        md12
        class="px-12 pb-12"
    >
        <PageHeader
            :breadcrumbs="breadcrumbs"
            :title="$t('page.user.title')"
            button
            :button-text="$t('page.user.new')"
            button-to="admin_user_new"
            search
            :search-label="$t('page.user.search')"
            @search-input="searchInputListener"
        />
        <v-row>
            <ActionBar
                new-button
                new-to="admin_user_new"
                :new-label="$t('page.user.new')"
                fetch
                :fetch-function="fetchData"
            />
            <v-col cols="12">
                <v-progress-linear
                    v-if="loading"
                    indeterminate
                    color="primary"
                />
                <v-skeleton-loader
                    v-if="loading"
                    class="mx-auto"
                    type="table-tbody"
                />
                <UsersList
                    v-if="!loading"
                    :users="users"
                    :search="textSearch"
                />
            </v-col>
        </v-row>
    </v-flex>
</template>

<script>

import ActionBar from '@/components/common/ActionBar';
import PageHeader from '@/components/common/PageHeader';
import UsersList from '@/components/users/UsersList';
import UserProxy from '@/proxies/UserProxy';

import { SuccessSnackbar, ObjectDeleted } from '@/app-events.js';

export default {
    name: 'UserIndex',
    components: {
        ActionBar,
        PageHeader,
        UsersList,
    },
    data() {
        return {
            breadcrumbs: [
                {
                    text: this.$t('page.home.title'),
                    exact: true,
                    to: { name: 'home' },
                },
                {
                    text: this.$t('page.admin.title'),
                    disabled: true,
                    href: '/admin',
                },
                {
                    text: this.$t('page.user.title'),
                    disabled: true,
                    exact: true,
                    to: { name: 'admin_users' },
                },
            ],
            textSearch: '',
            users: [],
            loading: true,
        };
    },
    created () {
        this.fetchData();
        this.$eventBus.listen(ObjectDeleted, (event) => {
            this.$eventBus.dispatch(new SuccessSnackbar(this.$t('user.actions.deleted')));
            for (let i = 0; i < this.users.length; i++) {
                const user = this.users[ i ];
                if (user.id === event.object.id) {
                    this.users.splice(i, 1);
                    break;
                }
            }
        });
    },
    methods: {
        fetchData() {
            this.loading = true;
            new UserProxy().all().then(({ data }) => {
                this.users = data.data;
                this.loading = false;
            }).catch(({ data }) => {
                this.displayError(data);
            });
        },
        searchInputListener(value) {
            this.textSearch = value;
        },
    },
};
</script>
